<!--
  This is the property of FRBNY and cannot be shared or disclosed without consent and strictly prohibited.
  
  Top Navy Bar and Wordmark Component
  Generated by: AI-DLC Workflow
-->
<template>
      <header class="app-header">
    <div class="top-navy-bar"></div>
    <div class="frbny-wordmark">
      <router-link to="/" class="logo-link" aria-label="Return to home">
        <img 
          :src="logoImage" 
          alt="FEDERAL RESERVE BANK OF NEW YORK" 
          class="wordmark-image"
        />
      </router-link>
    </div>
  </header>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import logoImg from '@/assets/styles/images/frb-logo.png';

const logoImage = computed(() => logoImg);
</script>

<style scoped>
.app-header {
  width: 100%;
}

.top-navy-bar {
  width: 100%;
  height: 16px;
  background-color: #002B49;
  flex-shrink: 0;
}

.frbny-wordmark {
  max-width: 1000px;
  width: 100%;
  margin: 40px auto 0;
  padding: 0 0.75rem;
}

.logo-link {
  display: inline-block;
  cursor: pointer;
  transition: opacity 0.2s ease;
}

.logo-link:hover {
  opacity: 0.8;
}

.logo-link:focus-visible {
  outline: 2px solid #003d7a;
  outline-offset: 4px;
  border-radius: 2px;
}

.wordmark-image {
  height: 16px;
  width: auto;
  display: block;
}

/* Responsive */
@media (max-width: 768px) {
  .frbny-wordmark {
    margin: 24px auto 0;
    padding: 0 20px;
    overflow: visible;
  }

  .wordmark-image {
    height: auto;
    width: 100%;
    max-width: 280px;
    max-height: 16px;
  }
}

/* Extra small mobile devices */
@media (max-width: 480px) {
  .frbny-wordmark {
    padding: 0 16px;
  }

  .wordmark-image {
    max-width: 240px;
    max-height: 14px;
  }
}
</style>
